// src/directives/permission.js

import { UserPermissionService } from "@/services/UserPermission.service";

export default {
  async inserted(el, binding, vnode) {
    const permission = binding.value;
    await updateVisibility(el, vnode, permission);
  },

  async update(el, binding, vnode) {
    const permission = binding.value;
    await updateVisibility(el, vnode, permission);
  },
};

async function updateVisibility(el, vnode, permission) {
  getPermission(vnode.context.$store);
  let userPermissions = [];
  if (permission?.includes("btn::")) {
    userPermissions =
      vnode.context.$store.getters["userPermission/userPermissions"];
  } else userPermissions = await getPermission(vnode.context.$store);

  const hasPermission = userPermissions?.includes(
    permission?.replace("btn::", "")
  );

  if (!hasPermission) {
    el.style.display = "none";
  } else {
    el.style.display = "";
  }
}

export async function getPermission($store) {
  const useName = $store.getters["getUsername"];
  let userPermissions = $store.getters["userPermission/userPermissions"];

  return UserPermissionService.getUserPermissions().then(
    (resuserPermissions) => {
      $store.commit("userPermission/setUserPermissions", {
        userName: useName,
        permissions: resuserPermissions,
      });
      userPermissions = resuserPermissions;
      return userPermissions;
    }
  );
}
